module.exports = __webpack_public_path__ + "img/PowerOfTakt-TheWorkpackage.24472322.png";